import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-h2',
    templateUrl: './h2.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class H2Component implements OnInit {
  constructor() {}

  ngOnInit() {}
}
